<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <identity-dictionary-selection
        v-model="innerValue"
        :error-messages="errors"
        :readonly="readonly"
        :label="label"
        :required-color="requiredColor"
        :required="required"
        :dense="dense"
        :prepend-icon="prependIcon"
        :dictionary-type="dictionaryType" />
  </ValidationProvider>
</template>

<script>
  import IdentityDictionarySelection from './IdentityDictionarySelection.vue'

  export default {
    components: {
      IdentityDictionarySelection
    },
    props: {
      value: {
        type: [String, Number],
        default: null
      },
      rules: [String, Object],
      label: {
        type: String,
        default: ''
      },
      prependIcon: {
        type: String
      },
      readonly: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      vid: {
        type: String,
        default: null
      },
      dictionaryType: {
        type: String,
        required: true
      },
      dense: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') && !!this.rules.length && this.rules.includes('required'))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            this.innerValue = newVal
          }
        }
      },
      innerValue (val) {
        this.$emit('input', val)
        if (val !== this.value) {
          this.$emit('change', val)
        }
      }
    }
  }
</script>
